// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Controls_wrap__eMPUb","icon":"Controls_icon__Go66W"};